import { useSelector } from "react-redux";

const useManageRole = () => {
  const { user } = useSelector((state) => state.user);

  let isDashboard = false;
  let isSport = false;
  let isTournament = false;
  let isMatch = false;
  let isMarket = false;
  let isFancy = false;
  let isLine = false;
  let isBookmaker = false;
  let isImport = false;
  let isOpenGame = false;
  let isUser = false;
  let isRole = false;
  let isGameSetting = false;
  let isUserSetting = false;
  let isWhiteLabelSetting = false;
  let isCommentary = false;
  let isLiveTv = false;
  let isIndependent = true;

  if (user) {
    user?.role?.modules &&
      user?.role?.modules.length > 0 &&
      user?.role?.modules.map((role) => {
        // dashboard
        if (role.moduleName.toLowerCase() === "dashboard") isDashboard = true;

        //game
        if (role.moduleName.toLowerCase() === "sport") isSport = true;
        if (role.moduleName.toLowerCase() === "tournaments")
          isTournament = true;
        if (role.moduleName.toLowerCase() === "matches") isMatch = true;
        if (role.moduleName.toLowerCase() === "market") isMarket = true;
        if (role.moduleName.toLowerCase() === "fancy") isFancy = true;
        if (role.moduleName.toLowerCase() === "line") isLine = true;
        if (role.moduleName.toLowerCase() === "bookmaker") isBookmaker = true;
        if (role.moduleName.toLowerCase() === "import") isImport = true;

        // report
        if (role.moduleName.toLowerCase() === "opengame") isOpenGame = true;

        // role management
        if (role.moduleName.toLowerCase() === "user") isUser = true;
        if (role.moduleName.toLowerCase() === "role") isRole = true;

        // global setting
        if (role.moduleName.toLowerCase() === "gamesetting")
          isGameSetting = true;
        if (role.moduleName.toLowerCase() === "usersetting")
          isUserSetting = true;
        if (role.moduleName.toLowerCase() === "whitelabelsetting")
          isWhiteLabelSetting = true;

        // configuration
        if (role.moduleName.toLowerCase() === "commentary") isCommentary = true;
        if (role.moduleName.toLowerCase() === "livetv") isLiveTv = true;
      });
  } else {
    console.log("user not found");
  }

  return {
    isDashboard,
    isSport,
    isTournament,
    isMatch,
    isMarket,
    isFancy,
    isLine,
    isBookmaker,
    isImport,
    isOpenGame,
    isUser,
    isRole,
    isGameSetting,
    isUserSetting,
    isWhiteLabelSetting,
    isLiveTv,
    isCommentary,
    isIndependent,
  };
};

export default useManageRole;
